/** 行政OA **/

import Layout from "@/views/layout/Layout";

const administrationOARouter = {
  path: "/administrationOA",
  component: Layout,
  name: "administrationOA",
  meta: {
    title: "行政OA",
    icon: "form",
    roles: ["xingzhengoa"]
  },
  children: [
    {
      path: "fromsApp",
      component: () => import("@/views/administrationOA/workspace/oa/FromsApp"),
      name: "单据提报",
      meta: {
        title: "单据提报",
        roles: ["xingzhengoa"]
      },
      children: []
    },
    {
      path: "unFinished",
      component: () =>
        import("@/views/administrationOA/workspace/oa/UnFinished.vue"),
      name: "待办事项",
      meta: {
        title: "待办事项",
        roles: ["xingzhengoa"]
      },
      children: []
    },
    {
      path: "finished",
      component: () =>
        import("@/views/administrationOA/workspace/oa/Finished.vue"),
      name: "已办事项",
      meta: {
        title: "已办事项",
        roles: ["xingzhengoa"]
      },
      children: []
    },
    {
      path: "mySubmit",
      component: () =>
        import("@/views/administrationOA/workspace/oa/MySubmit.vue"),
      name: "已发事项",
      meta: {
        title: "已发事项",
        roles: ["xingzhengoa"]
      },
      children: []
    },
    {
      path: "CcMe",
      component: () => import("@/views/administrationOA/workspace/oa/CcMe.vue"),
      name: "知会事项",
      meta: {
        title: "知会事项",
        roles: ["xingzhengoa"]
      },
      children: []
    },
    {
      path: "daibanList",
      component: () => import("@/views/administrationOA/workspace/oa/daibanList.vue"),
      name: "待办列表",
      meta: {
        title: "待办列表",
        roles: ["oa_daibanliebiao"]
      },
      children: []
    },

    {
      path: "processInstanceManage",
      component: () =>
        import("@/views/administrationOA/admin/ProcessInstanceManage.vue"),
      name: "数据管理",
      meta: {
        title: "数据管理",
        roles: ["shujuguanli"]
      },
      children: []
    },

    {
      path: "formsPanel",
      component: () => import("@/views/administrationOA/admin/FormsPanel"),
      name: "流程管理",
      meta: {
        title: "流程管理",
        roles: ["liuchengguanlioa"]
      },
      children: []
    },

    {
      path: "formProcessDesign",
      component: () =>
        import("@/views/administrationOA/admin/FormProcessDesign"),
      name: "流程设置",
      meta: {
        title: "流程设置"
      },
      hidden: true,
      children: []
    },
    // ======= app

    // 单据详情
    {
      path: "AppFormAuth",
      component: () =>
        import("@/views/administrationOA/workspace/approval/AppFormAuth"),
      name: "单据详情",
      meta: {
        title: "单据详情"
      },
      hidden: true,
      children: []
    },

    {
      path: "mbInitiateProcess",
      component: () =>
        import("@/views/administrationOA/workspace/MbInitiateProcess"),
      name: "发起审批",
      meta: {
        title: "发起审批"
      },
      hidden: true,
      children: []
    }

    // //////////////////
  ]
};

export default administrationOARouter;
